import { collectFaqItems } from '@/utils/faq-items';

export const TUTORIALS_BLOCK_TYPENAME = 'ComponentComponentsTutorialsBlock';

// TutorialsBlock renders different content based on the rest of the URL
// (/{categoryId}/{itemId}). For canonical purposes, only treat the deep path
// as meaningful when it resolves to a real category+item — anything else
// falls back to the same listing view as the root page and must canonicalize
// to the root to avoid duplicate-content URLs.
export function resolveTutorialsDeepPath(restOfPath, content) {
  const parts = (restOfPath || '').split('/').filter(Boolean);
  if (parts.length !== 2) return '';
  const [categoryId, itemId] = parts;
  const categories = collectFaqItems(content, TUTORIALS_BLOCK_TYPENAME, 'categories');
  const category = categories.find((c) => c.categoryId === categoryId);
  if (!category) return '';
  const item = (category.items || []).find((i) => i.itemId === itemId);
  if (!item) return '';
  return `/${categoryId}/${itemId}`;
}
